<template>
    <div id="stations_modal">
        <div class="ui basic modal stations" v-if="is_initialized">
            <div class="ui icon header">
                <i class="large icons">
                    <i class="inbox icon"></i>
                </i>
                <div v-if="$store.getters['provider/is_current_staff_minimalist_layout']">
                    <h2 v-if="$store.getters['provider/current_station']">
                        <!--
                            已啟用自動判定
                            更改當前站點
                        -->
                        {{
                            current_store.is_auto_gps_station_position_by_60s
                            ? $t('ui.toolbox.stations_modal.turn_on_auto_tracking')
                            : $t('ui.toolbox.stations_modal.modify_current_station')
                        }}
                    </h2>
                    <h2 v-else>
                        <!-- 請先選擇當前站點 -->
                        {{ $t('ui.toolbox.stations_modal.please_select_the_current_station') }}
                    </h2>
                </div>
                <div v-else>
                    <h2>
                        <!-- 您並非管理者, 今後更換站點 請聯絡管理員 -->
                        {{ $t('ui.toolbox.stations_modal.you_are_not_a_manager_will_modify_station_please_contact_the_manager') }}
                    </h2>
                    <h2 v-show="staff_not_manager_first_select_station">
                        <!-- 您目前無站點, 選完會更新您的使用者資料 -->
                        {{ $t('ui.toolbox.stations_modal.you_do_not_belong_station_will_update_your_data_after_selection') }}
                    </h2>
                </div>
            </div>

            <div class="content center aligned">
                <div v-if="current_store.is_auto_gps_station_position_by_60s">
                    <h2 style="color:white;">
                        <span v-if="current_position.is_first_initialized">
                            <!-- 當前站點： -->
                            {{ $t('ui.toolbox.stations_modal.current_station') }}：
                            <span>
                                {{ $store.getters['provider/current_station'].name || $t('ui.general.no') }}
                            </span>
                        </span>
                        <span v-else>
                            <span v-if="current_position.status == 'failure'">
                                {{ current_position.messages }}
                            </span>
                            <span v-else>
                                <!-- 請求GPS <div class="ui active inline loader"></div> 判定中 -->
                                {{ $t('ui.toolbox.stations_modal.tracking_GPS') }}
                                <div class="ui active inline loader"></div>
                                {{ $t('ui.toolbox.stations_modal.decisioning') }}
                            </span>
                        </span>
                    </h2>
                </div>
                <div v-else>
                    <div v-dropdown class="ui selection dropdown">
                        <div class="text">
                            <span>
                                {{ $store.getters['provider/current_station'].name || $t('ui.general.please_select') }}
                            </span>
                        </div>
                        <i class="dropdown icon"></i>
                        <div class="menu"
                            :style="{minHeight: (stations.length > 4) ? '220px' : ''}">
                            <div class="item"
                                @click.prevent="current_station.identity = current_station.name = null"
                                :class="{
                                    'selected active': current_station.identity == null
                                }">
                                <!-- 取消當前站點 -->
                                {{ $t('ui.toolbox.stations_modal.cancel_current_station') }}

                            </div>
                            <div
                                v-for="station in stations"
                                @click.prevent="current_station = _.cloneDeep(station)"
                                class="item"
                                :class="{
                                    'selected active': current_station.identity == station.identity
                                }">
                                {{ station.name }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="actions">
                <div class="ui teal inverted button"
                    :class="{active: is_auto_gps_station_position_once}"
                    @click="current_store.is_auto_gps_station_position_once = !is_auto_gps_station_position_once">
                    <i class="crosshairs icon"></i>
                    <!-- 自動判定(一次) -->
                    {{ $t('ui.toolbox.stations_modal.btns.track_once') }}
                </div>

                <div class="ui blue inverted button"
                    :class="{active: is_auto_gps_station_position_by_60s}"
                    @click="current_store.is_auto_gps_station_position_by_60s = !is_auto_gps_station_position_by_60s">
                    <i class="crosshairs icon"></i>
                    <!-- 每分鐘自動判定 -->
                    {{ $t('ui.toolbox.stations_modal.btns.auto_tracking_every_minute') }}
                </div>

                <div class="ui green ok inverted button"
                    @click="update_staff()">
                    <i class="checkmark icon"></i>
                    {{ $t('ui.general.update') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            is_initialized: false,
            current_station: {
                identity: null,
                name: null,
            },
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider
        },
        is_auto_gps_station_position_once() {
            return this.current_store.is_auto_gps_station_position_once
        },
        is_auto_gps_station_position_by_60s() {
            return this.current_store.is_auto_gps_station_position_by_60s
        },
        current_position() {
            return this.current_store.current_position
        },
        current_staff() {
            return this.current_store.current_staff
        },
        stations() {
            return this.current_store.stations
        },
        staff_not_manager_first_select_station() {
            if (!this.$store.getters['provider/is_current_staff_minimalist_layout'] &&
                !this.current_staff.station_identity
            ) {
                return true
            }
            return false
        },
        staff_can_select_station() {
            if (this.$store.getters['provider/is_current_staff_minimalist_layout']) {
                return true
            }else {
                return (!this.current_staff.station_identity)
                    ? true
                    : false
            }
        },
    },
    watch: {
        'current_store.is_auto_gps_station_position_once'(value) {
            this.current_store.is_auto_gps_station_position_once = false
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.current_station = this.$store.getters['provider/current_station']
                this.is_initialized = true
            })
        },
        update_staff() {
            if (!this.current_store.is_auto_gps_station_position_by_60s) {
                try {
                    this.$store.dispatch('provider/update_current_staff_station_identity', this.current_station)
                    if (!this.current_station.name) {
                        // this.$noty.warning('已取消站點')
                        this.$noty.warning(
                            this.$t('ui.general.cancel') + ' ' +
                            this.$t('models.stations')
                        )
                    }else {
                        // this.$noty.success('更新站點為：'+this.current_station.name)
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.$t('models.stations')
                            })
                        )
                    }
                } catch (e) {
                    // this.$noty.error('無法更新站點')
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.stations')
                        })
                    )
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
    .stations_modal {
        .content {
            text-align: center !important;
        }
    }
    .center.aligned {
        text-align: center;
    }
    @media screen and (max-height: 600px) {
        .modal.stations {
            margin-top: -200px !important;
        }
    }
</style>
